module.exports = __webpack_public_path__ + "static/media/incident_category-civil_unrest.17d8bd45.svg";